import React from "react";

const PremiumTag = () => {
  return <span className="premium-feature-text">*License</span>;
};

export default PremiumTag;
